var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGongFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M29.33611 3.78394v.78378l-3.54319-.00078.07231.07186-5.77144 5.88487c2.37632 1.64612 3.93571 4.39216 3.93571 7.49582-.0047 5.01857-4.09213 9.106-9.11148 9.1107-5.02406 0-9.11149-4.08743-9.11149-9.11148 0-3.13723 1.5938-5.90924 4.01422-7.54886l-5.7558-5.86849.03497-.03442L.5 4.56772v-.78378h28.83611zm-14.4181 11.49074c-1.51583 0-2.74402 1.22819-2.74402 2.74403s1.22819 2.74403 2.74403 2.74403c1.51583 0 2.74402-1.2282 2.74402-2.74403 0-1.51584-1.22819-2.74403-2.74402-2.74403zm9.61591-10.70774h-19.103l5.27321 5.37456c1.26088-.66047 2.69456-1.03428 4.21389-1.03428 1.55394 0 3.01828.39103 4.29978 1.07989l5.31612-5.42017zm4.8022-.3911H.49991"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGongFilled);
export default __webpack_public_path__ + "static/media/gong-filled.52a9f887.svg";
export { ForwardRef as ReactComponent };